






















import { Component, Prop, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import Table from '@/components/Table/Index.vue';
import StatementBody from '@/components/Table/StatementBody.vue';
import Pagination from '@/components/Pagination.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Pagination,
    StatementBody,
  },
})
export default class Statement extends Mixins(ErrorHandleMixin, PaginationMixin) {
  @Prop() readonly statementCriteria!: any;

  @Prop() readonly period!: any;

  @Prop() readonly currencyRate!: any;

  @Prop() readonly toggleMode!: boolean;

  StatementInstance = getModule(StatementModule, this.$store);

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  dataList: any = [];

  TableHead = DepositWithdrawData.TableHeadDetail;

  sum = 0;

  created() {
    this.fetchStatement();
  }

  async fetchStatement() {
    const criteria = { ...this.statementCriteria, ...this.period };
    const res = await this.StatementInstance.FetchStatementDetail(criteria);
    if (res.code) {
      this.checkError(res);
    } else {
      this.calPagination({
        instance: 'StatementInstance',
        dataKey: 'dataStatementDetail',
      });
      this.sum = this.StatementInstance.dataStatementDetail
        .reduce((acc, cur: any) => (acc + cur.amount), 0);
    }
  }
}
